import AxiosInstance from "../config/AxiosInstance";

const loadTranslation = async (page: any, limit: any, searchValue: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/translations/list', {
            params: {
                page: page,
                limit: limit,
                searchValue: searchValue
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
}

const loadListKey = async () => {
    try {
        const { data } = await AxiosInstance.get('/api/language/getTranslations');
        return { data };
    } catch (error) {
        throw error;
    }
}

const createTranslation = async (data: any) => {
    try {
        const response = await AxiosInstance.post('/api/translations', data);
        return response;
    } catch (error) {
        throw error;
    }
}
const createLanguage = async (data: any) => {
    try {
        const response = await AxiosInstance.post('/api/language', data);
        return response;
    } catch (error) {
        throw error;
    }
}

const loadLanguage = async (page: any, limit: any, searchValue: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/language', {
            params: {
                page: page,
                limit: limit,
                searchValue: searchValue
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
}

const loadDetailLanguage = async (id: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/language/' + id);
        return { data };
    } catch (error) {
        throw error;
    }
}
const updatdeLanguage = async (id: any, payload: any) => {
    try {
        const { data } = await AxiosInstance.put('/api/language/' + id, payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

const deleteLanguage = async (id: any) => {
    try {
        const { data } = await AxiosInstance.delete('/api/language/' + id);
        return { data };
    } catch (error) {
        throw error;
    }
}

const loadDetailTranslation = async (id: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/translations/' + id);
        return { data };
    } catch (error) {
        throw error;
    }
}
const updatdeTranslation = async (id: any, payload: any) => {
    try {
        const { data } = await AxiosInstance.put('/api/translations/' + id, payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

const deleteTranslation = async (id: any) => {
    try {
        const { data } = await AxiosInstance.delete('/api/translations/' + id);
        return { data };
    } catch (error) {
        throw error;
    }
}

export {
    loadTranslation,
    createLanguage,
    loadLanguage,
    loadDetailLanguage,
    updatdeLanguage,
    deleteLanguage,
    createTranslation,
    loadDetailTranslation,
    updatdeTranslation,
    deleteTranslation,
    loadListKey
}